import React from "react";
import {
  Shield,
  CheckCircle2,
  Award,
  Lock,
  FileText,
  ArrowRight,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { LeadConsultationForm } from "@/components/LeadConsultationForm";

export const ServiceCommitmentsPage: React.FC<{
  onOpenConsultation: () => void;
}> = ({ onOpenConsultation }) => {
  const commitments = [
    {
      title: "Complete Financial Transparency",
      desc: "No unvetted vendor markups or hidden fees. Full itemized invoices with every monthly statement.",
      icon: Shield,
    },
    {
      title: "Rigorous Multi-Stage Tenant Screening",
      desc: "Comprehensive criminal, credit, employment, and rental history verifications on every adult applicant.",
      icon: CheckCircle2,
    },
    {
      title: "Prompt Owner Disbursements",
      desc: "Fast electronic ACH transfers executed monthly directly to your preferred bank account.",
      icon: Lock,
    },
    {
      title: "24/7 Rapid Emergency Response",
      desc: "Our dispatch team and vetted emergency contractors protect your asset day and night.",
      icon: Award,
    },
  ];

  return (
    <div className="pt-24 pb-20 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <span className="text-xs font-extrabold uppercase tracking-widest text-primary bg-primary/10 px-3 py-1 rounded-md">
            Our Promises To Property Owners
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            Service Commitments & Standards
          </h1>
          <p className="text-slate-600 dark:text-slate-300 text-base">
            We hold ourselves to the highest standards of professional service,
            accountability, and fiduciary care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {commitments.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={i}
                className="bg-white dark:bg-slate-900 p-8 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-md"
              >
                <div className="p-3 rounded-xl bg-primary/10 text-primary w-fit mb-4">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
                  {c.title}
                </h3>
                <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                  {c.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="max-w-3xl mx-auto">
          <LeadConsultationForm title="Experience Premium Management Service" />
        </div>
      </div>
    </div>
  );
};
